import styled from 'styled-components';

import { StyleColor } from '../../../utils/styles-constants';
import { hexToRgba } from '../../../utils/style';

interface WrapperProps {
	slidesLength: number;
	currentSlideIndex: number;
}

const Wrapper = styled('div')`
	height: calc(100% - 60px);

	.slick-slider {
		height: 100%;
		margin: 0 auto;

		.slick-track {
			display: flex;
			align-items: center;

			${({ slidesLength }: WrapperProps) => slidesLength === 1 && 'justify-content: center;'}
		}

		.slick-slide {
			height: auto;
		}
	}

	.slick-list,
	.slick-track,
	.slick-active > div {
		height: 100%;
	}

	.slick-center {
		position: relative;
		z-index: 100;
	}

	.slick-slide {
		transform-style: preserve-3d;
		perspective: 500px;
		backface-visibility: hidden;
		transition: all 0.5s ease;
		outline: none;

		> div {
			transition: all 0.5s ease;
			-webkit-box-reflect: below 1px -webkit-linear-gradient(bottom, rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.1) 20%, rgba(0, 0, 0, 0) 30%, rgba(0, 0, 0, 0));
		}

		.is-dragging & {
			> div {
				pointer-events: none;
			}
		}
	}

	.slick-slide:not(.slick-current) {
		> div {
			transform: rotateY(15deg);
		}
	}

	.slick-current ~ .slick-slide > div {
		transform: rotateY(-15deg);
	}

	.slick-current > div {
		transform: scale(1.2);
		border-radius: 9px; /* TODO: configurable in admin from 0 to 9px */
		box-shadow: 0 10px 10px 5px ${hexToRgba(StyleColor.Black, 10)};
	}

	${({ currentSlideIndex }: WrapperProps) => `
		.slick-slide:not(.slick-current)[data-index="${currentSlideIndex - 1}"],
		.slick-slide:not(.slick-current)[data-index="${currentSlideIndex + 1}"] {
			> div {
				opacity: 0.9;
			}
		}

		.slick-slide[data-index="${currentSlideIndex - 2}"],
		.slick-slide[data-index="${currentSlideIndex + 2}"] {
			> div {
				opacity: 0.8;
			}
		}

		.slick-slide[data-index="${currentSlideIndex - 3}"],
		.slick-slide[data-index="${currentSlideIndex + 3}"] {
			> div {
				opacity: 0.7;
			}
		}
	`}
`;

const StyledArrow = styled('svg')`
	z-index: 1;
	fill: ${StyleColor.Black};
	pointer-events: all;

	&.slick-prev,
	&.slick-next {
		box-sizing: border-box;
		width: 40px;
		height: 100px;
		padding: 0 14px;
	}

	&.slick-prev {
		left: 0;
	}

	&.slick-next {
		right: 0;
	}
`;

export {
	Wrapper,
	StyledArrow,
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CoverFlow/Slider/styles.ts